import { useEffect, useState } from 'react';
import "../styles/Panel.css";

function PanelAdmin() {
  const [eventos, setEventos] = useState([]);
  const [nuevo, setNuevo] = useState({ dia: '', hora: '', titulo: '', tema: '', plataforma: '', link: '' });
  const [frase, setFrase] = useState('');
  const BASE_URL = "https://streamer.tutorandy.xyz/php"
  // Obtener eventos
  const cargarEventos = () => {
    fetch(`${BASE_URL}/getEventos.php`)
      .then(res => res.json())
      .then(data => setEventos(data));
  };

  useEffect(() => {
    cargarEventos();
    fetch(`${BASE_URL}/getFrase.php`)
      .then(res => res.json())
      .then(data => setFrase(data.frase));
  }, [BASE_URL]);

  const agregarEvento = () => {
    fetch(`${BASE_URL}/addEvento.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(nuevo)
    }).then(() => {
      setNuevo({ dia: '', hora: '', titulo: '', tema: '', plataforma: '', link: '' });
      cargarEventos();
      console.log("1 o 2");
    });
  };

  const eliminarEvento = (index) => {
    fetch(`${BASE_URL}/deleteEvento.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ index })
    }).then(() => cargarEventos());
  };

  const actualizarFrase = () => {
    fetch(`${BASE_URL}/updateFrase.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ frase })
    });
  };

  return (
    <div className="admin-panel">
      <h1>Panel de Administración</h1>

      <h2>Frase motivacional</h2>
      <textarea value={frase} onChange={(e) => setFrase(e.target.value)} rows={3} />
      <button onClick={actualizarFrase}>Actualizar frase</button>

      <h2>Agregar evento</h2>
      {['dia', 'hora', 'titulo', 'tema', 'plataforma', 'link'].map((campo) => (
        <input key={campo} placeholder={campo} value={nuevo[campo]} onChange={e => setNuevo({ ...nuevo, [campo]: e.target.value })} />
      ))}
      <button onClick={agregarEvento}>Agregar</button>

      <h2>Eventos actuales</h2>
      <table>
        <thead>
          <tr>
            <th>#</th>
            <th>Día</th>
            <th>Hora</th>
            <th>Título</th>
            <th>Tema</th>
            <th>Plataforma</th>
            <th>Link</th>
            <th>Acción</th>
          </tr>
        </thead>
        <tbody>
          {eventos.map((evento, i) => (
            <tr key={i}>
              <td>{i + 1}</td>
              <td>{evento.dia}</td>
              <td>{evento.hora}</td>
              <td>{evento.titulo}</td>
              <td>{evento.tema}</td>
              <td>{evento.plataforma}</td>
              <td><a href={evento.link} target="_blank" rel="noopener noreferrer">Ir</a></td>
              <td><button onClick={() => eliminarEvento(i)}>Eliminar</button></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default PanelAdmin;
